<template>
  <h3 class="mb-2 font-semibold">Add QA Response</h3>

  <div class="flex space-x-2">
    <button
      class="px-2 py-1 rounded bg-emerald-800 text-white"
      @click="setResponse(true)"
    >
      {{ !isConfirmTier ? 'Confirm Code' : 'Ready to Transmit' }}
    </button>
    <button
      class="px-2 py-1 rounded bg-rose-800 text-white"
      @click="setResponse(false)"
    >
      {{ !isConfirmTier ? 'Reject Code' : 'Not Valid for Transmit' }}
    </button>
  </div>

  <div  class="disagree-section">
    <div v-if="response === false" class="mb-4">
      <label class="block text-sm font-medium mb-1 mt-2">Reject Reason:</label>
      <select
        v-model="disagree_reason"
        class="w-full p-2 border rounded"
      >
        <option v-for="option in disagree_reasons" :key="option" :value="option">
          {{ option }}
        </option>
      </select>
    </div>
    <div class="mb-4">
      <label class="block text-sm font-medium mb-1 mt-2">Explanation (please add if disagreeing with previous QA or rejecting code):</label>
      <textarea
        v-model="explanation"
        class="w-full p-2 border rounded"
        rows="3"
        :class="{ 'border-red-500': submitted && !explanation }"
      >
      </textarea>
    </div>
  </div>
  <Field_Errors :received_errors="field_errors" />
  <div  v-if="response === false" class="mt-4">
    <button
      class="px-2 py-1 bg-primary-500 text-white rounded hover:bg-primary-500"
      @click="submitForm"
    >
      Submit
    </button>
  </div>
</template>

<script>
import Field_Errors from '@/components/widgetcomponents/Field_Errors.vue';

export default {
  components: {Field_Errors},
  props: {
    taskTypeId: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    workType: {
      type: Object,
      default: null
    },
    taskId: {
      type: Number,
      default: null
    },
    taskMetadata: {
      type: Object,
      default: () => ({})
    },
    opportunities: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    isConfirmTier() {
      const name = (this.taskMetadata?.task_type_name || '').toLowerCase();
      return name.includes('confirm');
    },
  },
  data() {
    return {
      field_errors:[],
      response: null,
      disagree_reason: null,
      explanation: '',
      disagree_reasons:[
        'Clinical Indicator Insufficient',
        'Clinical Indicator linked to Another Diagnosis',
        'More Appropriate Code Identified',
        'Missed Suspect Code Opportunity (Remove)',
        'Administrative Error (Non-Coder Error)',
        'Data Error'
      ],
    }
  },
  methods: {
    getFormData() {
      if (this.response === true) {
        return {
          qa_concurrence: true,
          qa_explanation: this.explanation,
          workflow_type: 'suspect',
        };
      }
      if (this.response === false && this.disagree_reason && this.explanation) {
        return {
          qa_concurrence: false,
          qa_disagree_reason: this.disagree_reason,
          qa_explanation: this.explanation,
          workflow_type: 'suspect',
        };
      }
      return null;
    },
    setResponse(value) {
      this.response = value;
      // Reset form if user switches to "Agree"
      if (value === true) {
        this.disagree_reason = null;
        this.submitForm()
      }
    },
    submitForm() {
      this.field_errors=[]
      if (this.response === true) {
        this.$emit('submit', {
          index:this.index,
          qa_concurrence: true,
          qa_explanation: this.explanation,
        });
      }
      else {
        // If disagree, validate and emit data
        if (!this.disagree_reason || !this.explanation) {
          this.field_errors.push('Must provide both a status and explanation to submit')
        }
        else{
          this.$emit('submit', {
            index: this.index,
            qa_concurrence: false,
            qa_disagree_reason: this.disagree_reason,
            qa_explanation: this.explanation
          });
          this.response= null; // Reset response after submission
        }
      }

    }
  }
}
</script>
